import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tickets')({
  component: RouteComponent,
})

function RouteComponent() {
  return <iframe
      src="https://ticketcentre.godalming.ac.uk"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      title="Godalming College Ticket Centre">
  </iframe>
}
